import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";

// STATE AND STORE
// LIBS
import API from "../../api";
import Model from "../../models/bilets";
import validateForm from "../../lib/helpers/validateForm";
import { fioLitleTruncateFromObject } from "../../lib/helpers/strings";
import {
  getDateFormat,
  getDateReturnDaysString
} from "../../lib/helpers/dates";

// UI
import {
  Alerts,
  Box,
  Button,
  Input,
  Header,
  HeaderPage,
  Row,
  Col,
  ButtonGroup,
  P
} from "../../ui";

class BiletEditHistoryPage extends Component {
  /* --------------------------------------------------- */
  /* STATE  -------------------------------------------- */
  /* --------------------------------------------------- */
  state = {
    titleHeader: "Изменение истории залогового билета",
    history: {},
    bilet: {},
    form: {
      bilet_number: {
        value: "",
        isEdited: false,
        isError: false,
        errors: []
      },
      filial_id: { value: "", isEdited: false, isError: false, errors: [] },
      depositor_id: { value: "", isEdited: false, isError: false, errors: [] },
      user_id: { value: "", isEdited: false, isError: false, errors: [] },
      date_created: {
        value: "",
        isEdited: false,
        isDate: true,
        isError: false,
        errors: [],
        validate: Model.date_created
      },
      date_return: {
        value: "",
        isEdited: false,
        isDate: true,
        isError: false,
        errors: [],
        validate: Model.date_return
      },
      days: {
        value: "",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.days
      },
      days_new: {
        value: "",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.days_new
      },
      sum_items: {
        value: "",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.sum_items
      },
      sum_give: {
        value: "0",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.sum_give
      },
      percent: {
        value: "0",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.percent
      },
      sum_percent: {
        value: "0",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.sum_percent
      },
      sum_return: {
        value: "0",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.sum_return
      },
      comment: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.comment
      },
      hash: { value: "", isEdited: false, isError: false, errors: [] },
      hash_old: { value: "", isEdited: false, isError: false, errors: [] },
      created_at: {
        value: "",
        isEdited: false,
        isDate: true,
        isError: false,
        errors: [],
        validate: Model.created_at
      },
      updated_at: {
        value: "",
        isEdited: false,
        isDate: true,
        isError: false,
        errors: [],
        validate: Model.updated_at
      }
    },
    formHistory: {
      sum: {
        value: "",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.history.sum
      },
      created_at: {
        value: "",
        isEdited: false,
        isDate: true,
        isError: false,
        errors: [],
        validate: Model.created_at
      },
      updated_at: {
        value: "",
        isEdited: false,
        isDate: true,
        isError: false,
        errors: [],
        validate: Model.updated_at
      }
    },
    buttons: {
      save: {
        disabled: false,
        title: "Изменить историю"
      }
    }
  };

  /* --------------------------------------------------- */
  /* COMPONENT  ---------------------------------------- */
  /* --------------------------------------------------- */
  async componentDidMount() {
    const { historyId } = this.props.match.params;
    const historyBilet = await API.bilets.getOneHistory(historyId);

    if (historyBilet && historyBilet._field) {
      const { _field, ...history } = historyBilet;
      const bilet = _field;
      const { form, formFines, formHistory } = this.state;

      // Заполняем форму
      for (let key in form) {
        // Если филиал
        if (key === "filial_id") {
          form[key].value = bilet[key].name;
        } else if (key === "depositor_id" || key === "user_id") {
          form[key].value = fioLitleTruncateFromObject(bilet[key]);
        } else {
          if (form[key].isNumber) {
            form[key].value = String(bilet[key]) || "0";
          } else if (form[key].isDate) {
            form[key].value = getDateFormat(bilet[key]);
          } else {
            form[key].value = bilet[key] || "";
          }
        }
      }

      // История
      // Заполняем форму
      for (let key in formHistory) {
        if (key === "sum") {
          if (history._options && history._options[key]) {
            formHistory[key].value = String(history._options[key] || "") || "";
          } else {
            delete formHistory[key];
          }
        } else {
          if (formHistory[key].isNumber) {
            formHistory[key].value = String(history[key] || "") || "";
          } else if (formHistory[key].isDate) {
            formHistory[key].value = getDateFormat(history[key]);
          } else {
            formHistory[key].value = history[key] || "";
          }
        }
      }

      this.setState({ bilet, history, form, formFines, formHistory });
    }
  }

  /* --------------------------------------------------- */
  /* INPUT  -------------------------------------------- */
  /* --------------------------------------------------- */
  handleInput = e => {
    let value = e.target.value;
    let name = e.target.name;
    const { form } = this.state;

    if (name && form[name]) {
      if (form[name].isNumber) {
        value = String(value) || "";
      }

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  };

  handleDatepicker = (name, value) => {
    console.log("handleDatepicker in page:", name, value);

    this.setState(prevState => {
      return {
        form: {
          ...prevState.form,
          [name]: {
            ...prevState.form[name],
            value,
            isEdited: true,
            isError: false,
            errors: []
          }
        }
      };
    });
  };

  handleInputHistory = e => {
    let value = e.target.value;
    let name = e.target.name;
    const { formHistory } = this.state;

    if (name && formHistory[name]) {
      if (formHistory[name].isNumber) {
        value = String(value) || "";
      }

      this.setState(prevState => {
        return {
          formHistory: {
            ...prevState.formHistory,
            [name]: {
              ...prevState.formHistory[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  };

  handleDatepickerHistory = (name, value) => {
    console.log("handleDatepicker in page:", name, value);

    this.setState(prevState => {
      return {
        formHistory: {
          ...prevState.formHistory,
          [name]: {
            ...prevState.formHistory[name],
            value,
            isEdited: true,
            isError: false,
            errors: []
          }
        }
      };
    });
  };

  /* --------------------------------------------------- */
  /* SUBMIT -------------------------------------------- */
  /* --------------------------------------------------- */
  handleFormSubmit = async e => {
    e.preventDefault();

    // Билет
    const result = validateForm(this.state.form);

    this.setState({
      form: result.form
    });

    // История
    const resultHistory = validateForm(this.state.formHistory);
    this.setState({
      formHistory: resultHistory.form
    });

    // Success
    if (result.valid && resultHistory.valid) {
      const { save } = this.state.buttons;
      save.disabled = true;

      // Отключаем кнопку
      this.setState(prevState => {
        return {
          buttons: { ...prevState.buttons, save },
          loading: true
        };
      });

      save.disabled = false;

      const { form, formHistory } = this.state;
      const { historyId } = this.props.match.params;
      const optionsRequest = {};

      for (let nameItem in form) {
        if (form[nameItem].isEdited) {
          optionsRequest[nameItem] = form[nameItem].value;
        }
      }

      for (let nameItem in formHistory) {
        if (formHistory[nameItem].isEdited) {
          if (!optionsRequest.history) {
            optionsRequest.history = {};
          }
          optionsRequest.history[nameItem] = formHistory[nameItem].value;
        }
      }

      // Есть изменения?
      if (Object.keys(optionsRequest).length) {
        // Изменение текущего
        const resultUpdated = await API.bilets.editOneHistory(historyId, {
          ...optionsRequest
        });

        if (resultUpdated) {
          Alerts.success("История изменёна");

          // Включаем кнопку, данные сохранились
          this.setState(prevState => {
            return {
              buttons: { ...prevState.buttons, save }
            };
          });

          this.props.history.goBack();
        } else {
          Alerts.error("История не изменёна");

          // Включаем кнопку, данные не сохранились
          this.setState(prevState => {
            return {
              buttons: { ...prevState.buttons, save }
            };
          });
        }
      } else {
        Alerts.info("В истории нет изменений");

        // Включаем кнопку, данные не сохранились
        this.setState(prevState => {
          return {
            buttons: { ...prevState.buttons, save }
          };
        });

        this.props.history.goBack();
      }
    }
  };

  /* --------------------------------------------------- */
  /* RENDER -------------------------------------------- */
  /* --------------------------------------------------- */
  render() {
    const { id } = this.props.match.params;
    const { bilet, form } = this.state;

    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <form className="form" onSubmit={this.handleFormSubmit}>
          <HeaderPage
            title={this.state.titleHeader + " №" + form.bilet_number.value}
            back={this.props.history.goBack}
          >
            <ButtonGroup>
              <Button
                type="submit"
                theme="success"
                disabled={this.state.buttons.save.disabled}
              >
                {this.state.buttons.save.title}
              </Button>
              <Button
                type="button"
                onClick={() => this.props.history.goBack()}
                theme="default"
              >
                Отмена
              </Button>
            </ButtonGroup>
          </HeaderPage>

          <Box>
            <Header size={2} margin="no">
              История
            </Header>
            <P margin="no-top" size="small">
              На основе данных из истории формируется отчёт за день.
            </P>

            <br />

            <Row>
              <Col padding="no-top-left">
                <Input
                  label="Дата создания истории:"
                  name="created_at"
                  type="date"
                  value={this.state.formHistory.created_at.value}
                  errors={this.state.formHistory.created_at.errors}
                  handleChange={this.handleInputHistory}
                  handleChangeDate={this.handleDatepickerHistory}
                />
              </Col>
              <Col padding="no-top-left">
                <Input
                  label="Дата обновления истории:"
                  name="updated_at"
                  type="date"
                  value={this.state.formHistory.updated_at.value}
                  errors={this.state.formHistory.updated_at.errors}
                  handleChange={this.handleInputHistory}
                  handleChangeDate={this.handleDatepickerHistory}
                />
              </Col>
              <Col padding="no-top-left">
                {this.state.formHistory.sum ? (
                  <Input
                    label="Сумма в истории:"
                    name="sum"
                    value={this.state.formHistory.sum.value}
                    errors={this.state.formHistory.sum.errors}
                    handleChange={this.handleInputHistory}
                  />
                ) : null}
              </Col>
              <Col padding="no-top-left" />
              <Col padding="no-top-left" />
            </Row>
          </Box>

          <Box>
            <Header size={2} margin="no-top">
              Залоговый билет
            </Header>

            <Row>
              <Col padding="no-top-left">
                <Header size={5} margin="no-top">
                  Главное
                </Header>

                <Input
                  label="Номер з/б:"
                  name="bilet_number"
                  value={this.state.form.bilet_number.value}
                  disabled={true}
                />
                <Input
                  label="Филиал:"
                  name="filial_id"
                  value={this.state.form.filial_id.value}
                  disabled={true}
                />
              </Col>

              <Col padding="no-top-left">
                <Header size={5} margin="no-top">
                  Сроки
                </Header>

                <Input
                  label="Первая операция:"
                  name="date_created"
                  type="date"
                  value={this.state.form.date_created.value}
                  errors={this.state.form.date_created.errors}
                  handleChange={this.handleInput}
                  handleChangeDate={this.handleDatepicker}
                />
                <Input
                  label="Дата возврата:"
                  name="date_return"
                  type="date"
                  value={this.state.form.date_return.value}
                  errors={this.state.form.date_return.errors}
                  handleChange={this.handleInput}
                  handleChangeDate={this.handleDatepicker}
                />
                <Input
                  label="Всего дней:"
                  type="integer"
                  name="days"
                  value={this.state.form.days.value}
                  errors={this.state.form.days.errors}
                  handleChange={this.handleInput}
                />
                <Input
                  label="Когда возврат:"
                  name="days_return"
                  value={getDateReturnDaysString(
                    this.state.form.date_return.value,
                    true
                  )}
                  disabled={true}
                />
                {bilet.status === "continue" ? (
                  <Input
                    label="Продлён на:"
                    name="days_new"
                    value={this.state.form.days_new.value}
                    errors={this.state.form.days_new.errors}
                    handleChange={this.handleInput}
                  />
                ) : null}
              </Col>

              <Col padding="no-top">
                <Header size={5} margin="no-top">
                  Деньги
                </Header>

                <Input
                  label="Сумма оценки:"
                  type="number"
                  name="sum_items"
                  value={this.state.form.sum_items.value}
                  errors={this.state.form.sum_items.errors}
                  handleChange={this.handleInput}
                />
                <Input
                  label="Сумма выдачи:"
                  type="number"
                  name="sum_give"
                  value={this.state.form.sum_give.value}
                  errors={this.state.form.sum_give.errors}
                  handleChange={this.handleInput}
                />
                <Input
                  label="Используемый процент:"
                  type="number"
                  name="percent"
                  value={this.state.form.percent.value}
                  errors={this.state.form.percent.errors}
                  handleChange={this.handleInput}
                />
                <Input
                  label="Сумма процентов:"
                  type="number"
                  name="sum_percent"
                  value={this.state.form.sum_percent.value}
                  errors={this.state.form.sum_percent.errors}
                  handleChange={this.handleInput}
                />
                <Input
                  label="Сумма возврата:"
                  type="number"
                  name="sum_return"
                  value={this.state.form.sum_return.value}
                  errors={this.state.form.sum_return.errors}
                  handleChange={this.handleInput}
                />
              </Col>

              <Col padding="no-top">
                <Header size={5} margin="no-top">
                  Люди
                </Header>

                <Input
                  label="Залогодатель:"
                  name="depositor_id"
                  value={this.state.form.depositor_id.value}
                  disabled={true}
                />
                <Input
                  label="Ответсвенный:"
                  name="user_id"
                  value={this.state.form.user_id.value}
                  disabled={true}
                />
              </Col>

              <Col padding="no-top-right">
                <Header size={5} margin="no-top">
                  Изменения
                </Header>

                <Input
                  label="Дата создания з/б:"
                  name="created_at"
                  type="date"
                  dateRight={true}
                  value={this.state.form.created_at.value}
                  errors={this.state.form.created_at.errors}
                  handleChange={this.handleInput}
                  handleChangeDate={this.handleDatepicker}
                />
                <Input
                  label="Дата обновления з/б:"
                  name="updated_at"
                  type="date"
                  dateRight={true}
                  value={this.state.form.updated_at.value}
                  errors={this.state.form.updated_at.errors}
                  handleChange={this.handleInput}
                  handleChangeDate={this.handleDatepicker}
                />
              </Col>
            </Row>

            <br />

            <Row>
              <Col padding="no-top-left">
                <Input
                  label="Комментарий"
                  name="comment"
                  value={this.state.form.comment.value}
                  placeholder="Комментарий не задан"
                  errors={this.state.form.comment.errors}
                  handleChange={this.handleInput}
                />
              </Col>

              <Col padding="no-top">
                <Input
                  label="HASH-текущий:"
                  name="hash"
                  value={this.state.form.hash.value}
                  disabled={true}
                />
              </Col>

              <Col padding="no-top-right">
                <Input
                  label="HASH-предыдущий:"
                  name="hash_old"
                  value={this.state.form.hash_old.value}
                  disabled={true}
                />
              </Col>
            </Row>
          </Box>
        </form>

        <Box>
          <P text="center">
            Создать/изменить/удалить штраф можно только в изменении текущего
            состояния.
          </P>
          <Button
            type="as"
            as={Link}
            to={`/bilets/${id}/edit`}
            theme="primary"
            outline={true}
            block={true}
          >
            Перейти к изменению текущего состояния
          </Button>
        </Box>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default withAuth(connect(mapStateToProps)(BiletEditHistoryPage));
